import React, { useEffect, useState, useRef } from 'react';
import Box from "@mui/material/Box";
import axios from "axios";
import Constants from "./Constants";
import LinearProgress from "@mui/material/LinearProgress";
import { useNavigate } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import './Distributions.css';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';
import MultiRangeSlider from "./MultiRangeSlider";
import jetcb from "./images/jetcb.png";
import blueend from "./images/blueend.png";
import redend from "./images/redend.png";
import edit from "./images/edit.svg";
import Checkbox from '@mui/material/Checkbox';

function Distributions(props) {
    const navigate = useNavigate();
    const nSlicePeriods = 20; // 11;
    const [criteria, setCriteria] = useState(props.criteria);
    const [previousBurst, setPreviousBurst] = useState(props.sharedStore.getState().previousBurst);
    const [which_species, setSpecies] = useState({
        species: props.sharedStore.getState().species || props.info.species,
        time_delta: (nSlicePeriods * .15).toFixed(2) + " secs",
        currzoom_placeholder: "1500",
        nSlice: nSlicePeriods,
        plot_detail: props.sharedStore.getState().plot_detail || "browse",
        image_size: "450"
    });
    const [image_w, setImage_w] = useState(250);
    const [image_min, setImage_min] = useState(0);
    const [image_max, setImage_max] = useState(255);
    const [image_ext, setImage_ext] = useState(1);
    const [image_offset, setImage_offset] = useState(1);
    const [mytable, setTable] = useState({
        response: null,
        rDist: props.rDist,
        rDistCurrent: "electron0",
        redirect: null,
        order: 'asc',
        sharedStore: props.sharedStore,
        selected: [],
        page: 0,
        rowsPerPage: 25,
        counter: 0,
        data: null,
        bulkv: true,
        rotation: 'B',
        thickness: 3,
        elecEnergyMax: 18
    });
    const [status, setProgStatus] = useState("Processing");
    const [progressPercent, setPercent] = useState(0);
    const timerRef = useRef(null);
    const [reload, setReload] = useState(false);
    const [linePos, setLinePos] = useState('');
    const [editTime, setEditTime] = useState(false);
    const [lineTime, setLineTime] = useState({
        date: '',
        hour: '',
        min: '',
        sec: '',
        mil: '',
    });

    const [skipTime, setSkipTime] = useState('1.8 sec');
    const [deltaTime, setDeltaTime] = useState('.15 sec');
    const [hideBurstVar, setHideBurstVar] = useState(false);
    const [delayHideVar, setDelayHideVar] = useState(false);
    const [disableAccordion, setDisableAccordion] = useState(false);
    const [matrix, setMatrix] = useState([['1.0', '0', '0'],
    ['0', '1.0', '0'],
    ['0', '0', '1.0']]);

    const [showOptions, setShowOptions] = useState(false);
    const [enablePan, setEnablePan] = useState(false);
    const [currentRanges, setCurrentRanges] = useState({ x: null, y: null });
    const [startDist, setStartDist] = useState(false);

    const handleBulkVChange = (event) => {
        setTable({ ...mytable, bulkv: event });
    };
    function handleRotationChange(selected_rotation) {
        setTable({ ...mytable, rotation: selected_rotation });
    }
    const handleThickness = (event) => {
        if (parseInt(event) > 31) {
            event = "31"
        }
        if (parseInt(event) < 0) {
            event = "0"
        }
        setTable({ ...mytable, thickness: event });
    };

    const incrementhandleThickness = () => {
        let thicknessNumber = Number(mytable.thickness)
        thicknessNumber = thicknessNumber + 1;
        setTable({ ...mytable, thickness: thicknessNumber });
    };

    const decrementhandleThickness = () => {
        let thicknessNumber = Number(mytable.thickness)
        thicknessNumber = thicknessNumber - 1;
        setTable({ ...mytable, thickness: thicknessNumber });
    };

    //decrementZoomValue, incrementZoomValue

    const decrementSizeValue = () => {
        let sizeValueNumber = Number(which_species.image_size)
        sizeValueNumber = sizeValueNumber - 50;
        setSpecies({ ...which_species, image_size: '' + sizeValueNumber });
    }

    const incrementSizeValue = () => {
        let sizeValueNumber = Number(which_species.image_size)
        sizeValueNumber = sizeValueNumber + 50;
        setSpecies({ ...which_species, image_size: '' + sizeValueNumber });
    }

    const handleElecEnergyMax = (event) => {
        if (parseInt(event) > 31) {
            event = "31"
        }
        if (parseInt(event) < 0) {
            event = "0"
        }
        setTable({ ...mytable, elecEnergyMax: event });
    };



    const incrementElecEnergyMax = () => {
        let ElecEnergyMaxNumber = Number(mytable.elecEnergyMax)
        ElecEnergyMaxNumber = ElecEnergyMaxNumber + 1;
        setTable({ ...mytable, elecEnergyMax: ElecEnergyMaxNumber });
    };

    const decrementElecEnergyMax = () => {
        let ElecEnergyMaxNumber = Number(mytable.elecEnergyMax)
        ElecEnergyMaxNumber = ElecEnergyMaxNumber - 1;
        setTable({ ...mytable, elecEnergyMax: ElecEnergyMaxNumber });
    };

    const handleSliderChange = (event, newValue) => {
        setSpecies({ currzoom_placeholder: newValue });
        console.log('handleSliderChange which_species', which_species);
    }

    const handleInputChange = (event) => {
        setSpecies({ currzoom_placeholder: event.target.value })
        console.log('handleInputChange which_species', which_species);
    }

    const handleBlur = () => {
        if (which_species.currzoom_placeholder < 100) {
            setSpecies({ currzoom_placeholder: 100 })
        } else if (which_species.currzoom_placeholder > 10000) {
            setSpecies({ currzoom_placeholder: 100 })
        }
    };

    function setReloadWrapper(toggle) {
        // validate matrix value
        let error = false;
        if (mytable.rotation === "LMN") {
            for (let i = 0; i < matrix.length; i++) {
                for (let x = 0; x < matrix[i].length; x++) {
                    if (isNaN(matrix[i][x]) || matrix[i][x] < -1 || matrix[i][x] > 1) {
                        error = true;
                    }
                }
            }
        }
        if (error) {
            setReload(false);
        }
        else if (props.line_pos !== '') {
            setReload(toggle);
        } else {
            setReload(false);
        }
        return;
    }
    function incrementZoomValue() {
        let zoomNumber = Number(which_species.currzoom_placeholder)
        zoomNumber = zoomNumber + 100;
        setSpecies({ ...which_species, currzoom_placeholder: '' + zoomNumber });
    }

    function decrementZoomValue() {
        let zoomNumber = Number(which_species.currzoom_placeholder)
        zoomNumber = zoomNumber - 100;
        setSpecies({ ...which_species, currzoom_placeholder: '' + zoomNumber });
    }

    useEffect(() => {
        componentDidMount();
        return () => clearTimeout(timerRef.current);
    }, []);

    useEffect(() => {
        props.handleDist4.current = getDist_StatusMsgs
    }, [props.handleDist4.current]);

    useEffect(() => {
        props.dist_resize.current = resize;
    }, [props.dist_resize.current]);

    useEffect(() => {
        if (props.disableButton) {
            setLinePos('');
            setReloadWrapper(false);
        }
        if (props.line_pos && props.line_pos !== '') {
            setReloadWrapper(true);
        } else {
            setReloadWrapper(false);
        }
    }, [props.disableButton]);

    useEffect(() => {
        setReloadWrapper(true);
    }, [props.line_pos, mytable, matrix, which_species]);

    function closeOptionsDialog(event) {
        let dialogBox = document.getElementById('options-dialog-dist');
        const optionsButton = document.getElementById('open-options-button-dist');
        if (!dialogBox.contains(event.target) && !optionsButton.contains(event.target)) {
            setShowOptions(false);
            document.removeEventListener('click', closeOptionsDialog);
        }
    }

    useEffect(() => {
        if (showOptions) {
            document.addEventListener('click', closeOptionsDialog);
        } else {
            document.removeEventListener('click', closeOptionsDialog);
        }
    }, [showOptions]);

    function componentDidMount() {
        props.line_pos = props.sharedStore.getState().line_pos;
        console.log("distributions line_pos:", props.line_pos); // sitl return
    }

    const get_slider = (min, max) => {
        let factor = .75;
        let edgefactor = .75
        let b = 0;
        if ((max - min) < 150) {
            factor = .75;
        }
        if (image_min !== min || image_max !== max) {
            setReloadWrapper(true);
        }
        setImage_min(min);
        setImage_max(max);

        let i_w = Math.ceil((factor * (max - min) - b));
        let i_b = Math.ceil(min * edgefactor)
        setImage_w(i_w);
        setImage_offset(i_b);
        setImage_ext(195 - (i_w + i_b));
    }

    function trackPanZoom(gd) {
        gd.on('plotly_relayout', eventData => {
            let newObj = currentRanges// setCurrentRanges
            if (eventData['xaxis.range[0]'] !== undefined) {
                newObj.x = [
                    eventData['xaxis.range[0]'],
                    eventData['xaxis.range[1]']
                ];
            }
            if (eventData['yaxis.range[0]'] !== undefined) {
                newObj.y = [
                    eventData['yaxis.range[0]'],
                    eventData['yaxis.range[1]']
                ];
            }
            setCurrentRanges(newObj);
        });
    }

    function plotWithSavedRanges(id, data, layout) {
        if (currentRanges.x && currentRanges.y) {
            layout.xaxis.range = currentRanges.x;
            layout.yaxis.range = currentRanges.y;
        }
        Plotly.newPlot(id, data, layout ,
            {modeBarButtonsToRemove: [
                'zoom2d', 'pan2d', 'select2d', 'lasso2d','toImage',
                'zoomIn2d',  'resetScale2d',
                'hoverClosestCartesian', 'hoverCompareCartesian'
            ]
        }).then(gd => trackPanZoom(gd));
    }

    function figure_skip_time(species) {
        if (species == "ions") {
            let time_skip = nSlicePeriods * .15;
            let time_skip_string = time_skip.toFixed(2) + " secs";
            return time_skip_string
        }
        else {
            let time_skip = nSlicePeriods * .03;
            let time_skip_string = time_skip.toFixed(2) + " secs";
            return time_skip_string
        }
    }

    function change_time_label(ion_selected) {
        //This will need to be reworked
        let time_skip_str = figure_skip_time("electron");
        let time_delta_str = ".03 secs";
        if (ion_selected) {
            time_skip_str = figure_skip_time("ions");
            time_delta_str = ".15 secs";
        }
        setSkipTime(time_skip_str);
        setDeltaTime(time_delta_str);
        if (ion_selected) {
            setSpecies({ ...which_species, time_delta: time_delta_str, currzoom_placeholder: "1500" });
        } else {
            setSpecies({ ...which_species, time_delta: time_delta_str, currzoom_placeholder: "10000" });
        }
    }

    function setSpeciesHandler(selected_species) {
        let zommPlaceHolder = "1500";
        if (selected_species == "ions") {
            change_time_label(true);
            zommPlaceHolder = "1500";
        } else {
            change_time_label(false);
            zommPlaceHolder = "10000";
        }
        // if we stay on the page:
        setSpecies({ ...which_species, species: selected_species, currzoom_placeholder: zommPlaceHolder });
        // if we leave the page
        props.sharedStore.dispatch({
            type: 'SET_SPECIES', value: selected_species
        });
    }

    function setPlotHandler(plot_detail) {
        console.log('plot_detail', plot_detail);
        let nslice = 5;
        if (plot_detail == "browse") {
            nslice = 20; //11;
        }
        props.sharedStore.dispatch({
            type: 'SET_PLOT_DETAIL', value: plot_detail
        });
        setSpecies({ ...which_species, nSlice: nslice, plot_detail: plot_detail });
    }

    function next_file() {
        props.setCurrentStatus("Starting next workflow");
        // move slider is a date manipulating function in ResultsScreen
        props.sharedStore.dispatch({
            type: 'SET_LINEPOS',
            value: props.move_slider(props.line_pos, 1.0 * parseFloat((figure_skip_time(which_species.species)).slice(0, 4)))
        });
        console.log("Moving slider ", (figure_skip_time(which_species.species)).slice(0, 4));

        document.getElementById("progress0").style.visibility = "visible";
        document.getElementById("progress0").style.display = "inline";

        getDist_StatusMsgs(props.criteria.spacecraft, null, null, null,
            props.sharedStore.getState().previousBurst, "next");

        let newTime = props.sharedStore.getState().line_pos;
        update_main_slider_pos(newTime);
        setTimeObj(true);
    }

    function prev_file() {
        props.setCurrentStatus("Starting prev workflow");
        // move slider is a date manipulating function in ResultsScreen
        props.sharedStore.dispatch({
            type: 'SET_LINEPOS',
            value: props.move_slider(props.line_pos, -1.0 * parseFloat((figure_skip_time(which_species.species)).slice(0, 4)))
        });

        document.getElementById("progress0").style.visibility = "visible";
        document.getElementById("progress0").style.display = "inline";

        getDist_StatusMsgs(props.criteria.spacecraft, null, null, null,
            props.sharedStore.getState().previousBurst, "prev");

        let newTime = props.sharedStore.getState().line_pos;
        console.log('newTime', newTime);
        update_main_slider_pos(newTime);
        setTimeObj(true);
    }
    function same_time_file() {
        document.getElementById("burst-instructions").style.visibility = "hidden";
        document.getElementById("burst-instructions").style.display = "none";
        props.setCurrentStatus("Starting workflow");
        setPercent(1)
        document.getElementById("progress0").style.visibility = "visible";
        document.getElementById("progress0").style.display = "inline";
        getDist_StatusMsgs(props.criteria.spacecraft, null, null, null,
            props.line_pos, "same");
        setReloadWrapper(false)
        setTimeObj(true);
        bustVarAccordion();
    }
    // function slider_dist() {
    //     document.getElementById("slider-button").disabled = true;
    //     props.setCurrentStatus("Starting slider workflow");
    //     setPercent(1);
    //     let array = lineTime.date.split('-');
    //     let date = `${array[0]}-${array[1]}-${array[2]} ${lineTime.hour}:${lineTime.min}:${lineTime.sec}.${lineTime.mil}`;
    //     console.log('props.line_pos', props.line_pos);
    //     console.log('date', date);
    //     getDist_StatusMsgs(props.criteria.spacecraft, null, null, null,
    //         props.line_pos, null);
    //     setTimeObj(true);
    // }

    function setNewTime() {
        let validNumbersCheck = true;
        let plotDate = new Date(props.criteria.startTime);
        let plotDuration = props.criteria.duration
        if (props.criteria.units === 'hours') {
            if (isNaN(lineTime.hour) || +lineTime.hour < plotDate.getUTCHours() || +lineTime.hour >= plotDate.getUTCHours() + plotDuration) {
                // validate hour to date
                document.getElementById("burst-start-time-hour").classList.add("invalid");
                validNumbersCheck = false;
            }
        } else if (props.criteria.units === 'minutes') {
            if (isNaN(lineTime.min) || +lineTime.min < plotDate.getUTCMinutes() || +lineTime.min >= plotDate.getUTCMinutes() + plotDuration) {
                // validate Minutes to date
                document.getElementById("burst-start-time-min").classList.add("invalid");
                validNumbersCheck = false;
            }
        }
        if (isNaN(lineTime.hour) || +lineTime.hour < 0 || +lineTime.hour >= 24 || /[^\d]/.test(lineTime.hour)) { // validate hour
            document.getElementById("burst-start-time-hour").classList.add("invalid");
            validNumbersCheck = false;
        }
        if (isNaN(lineTime.min) || +lineTime.min < 0 || +lineTime.min >= 60 || /[^\d]/.test(lineTime.min)) { // validate min
            document.getElementById("burst-start-time-min").classList.add("invalid");
            validNumbersCheck = false;
        }
        if (isNaN(lineTime.sec) || +lineTime.sec < 0 || +lineTime.sec >= 60 || /[^\d]/.test(lineTime.sec)) { // validate sec
            document.getElementById("burst-start-time-sec").classList.add("invalid");
            validNumbersCheck = false;
        }
        if (isNaN(lineTime.mil) || +lineTime.mil < 0 || +lineTime.mil > 999 || /[^\d]/.test(lineTime.mil)) { // validate mil
            document.getElementById("burst-start-time-mil").classList.add("invalid");
            validNumbersCheck = false;
        }
        if (!validNumbersCheck) {
            return;
        }
        document.getElementById("burst-start-time-hour").classList.remove("invalid");
        document.getElementById("burst-start-time-min").classList.remove("invalid");
        document.getElementById("burst-start-time-sec").classList.remove("invalid");
        document.getElementById("burst-start-time-mil").classList.remove("invalid");


        props.setCurrentStatus("Starting new workflow");
        let array = lineTime.date.split('-');
        let date = `${array[0]}-${array[1]}-${array[2]} ${lineTime.hour}:${lineTime.min}:${lineTime.sec}.${lineTime.mil}`;
        props.setLine_pos(date);

        // move slider is a date manipulating function in ResultsScreen
        props.sharedStore.dispatch({
            type: 'SET_LINEPOS',
            value: props.move_slider(`${array[0]}-${array[1]}-${array[2]} ${lineTime.hour}:${lineTime.min}:${lineTime.sec}.${lineTime.mil}`, 0)
        });
        // props.move_slider(`${array[0]}-${array[1] - 1}-${array[2]} ${lineTime.hour}:${lineTime.min}:${lineTime.sec}.${lineTime.mil}`, 0);
        console.log("Moving slider ");

        // document.getElementById("progress0").style.visibility = "visible";
        // document.getElementById("progress0").style.display = "inline";

        // getDist_StatusMsgs(props.criteria.spacecraft, null, null, null,
        //     props.sharedStore.getState().previousBurst, "new");

        let newTime = props.sharedStore.getState().line_pos;
        update_main_slider_pos(newTime);
        setEditTime(!editTime);
        setReloadWrapper(true);
    };

    function DisplayNext(direction) {
        var hide = [];
        var divtop = which_species.nSlice - 1;
        var next_make_visible = ""
        var periods = []
        for (i = 0; i < which_species.nSlice; ++i) {
            periods.push(i)
        }
        console.log('divtop', divtop);
        periods.push(0)
        for (var elem = 0; elem <= divtop; ++elem) {
            if (mytable.rDistCurrent == "electron".concat(periods[elem].toString())) {
                setTable({ ...mytable, rDistCurrent: "electron".concat((periods[elem + direction]).toString()) }); /* set curr disp to next item */
                next_make_visible = "-dr".concat((periods[elem + direction]).toString()); /* this one we will make visible */
                for (var i = 0; i <= divtop; ++i) { /* all the rest will be hidden */
                    if (i != periods[elem + direction]) {
                        hide.push(periods[i]) /* hide all but the one next being displayed */
                    }
                }
                if (!document.getElementById("ele".concat(next_make_visible)).querySelector("svg")) {
                    /* if the plot hasn't already been loaded, load it in the next-to-be-shown  div */
                    plotWithSavedRanges('ele'.concat(next_make_visible), mytable.rDist.dist.electron[elem + direction].data, mytable.rDist.dist.electron[elem + direction].layout);
                    plotWithSavedRanges('ion'.concat(next_make_visible), mytable.rDist.dist.ion[elem + direction].data, mytable.rDist.dist.ion[elem + direction].layout);
                    plotWithSavedRanges('sl3'.concat(next_make_visible), mytable.rDist.dist.slice3[elem + direction].data, mytable.rDist.dist.slice3[elem + direction].layout);

                    const dRion0 = document.getElementById('ion'.concat(next_make_visible));
                    const dRele0 = document.getElementById('ele'.concat(next_make_visible));
                    const dRsl30 = document.getElementById('sl3'.concat(next_make_visible));
                    dRion0.on('plotly_relayout', eventData => {
                        if (eventData.hasOwnProperty('xaxis.range[0]')) {
                            onDistZoom('ion'.concat(next_make_visible), eventData, dRion0);
                        }
                    });
                    dRele0.on('plotly_relayout', eventData => {
                        if (eventData.hasOwnProperty('xaxis.range[0]')) {
                            onDistZoom('ele'.concat(next_make_visible), eventData, dRele0);
                        }
                    });
                    dRsl30.on('plotly_relayout', eventData => {
                        if (eventData.hasOwnProperty('xaxis.range[0]')) {
                            onDistZoom('sl3'.concat(next_make_visible), eventData, dRsl30);
                        }
                    });

                }
            }
        }

        document.getElementById("ion".concat(next_make_visible)).style.visibility = "visible";
        document.getElementById("ion".concat(next_make_visible)).style.display = "inline-block";
        document.getElementById("ele".concat(next_make_visible)).style.visibility = "visible";
        document.getElementById("ele".concat(next_make_visible)).style.display = "inline-block";
        document.getElementById("sl3".concat(next_make_visible)).style.visibility = "visible";
        document.getElementById("sl3".concat(next_make_visible)).style.display = "inline-block";


        for (let fix in hide) {
            let sfix = "-dr".concat((hide[fix]).toString());
            document.getElementById("ele".concat(sfix)).style.visibility = "hidden";
            document.getElementById("ele".concat(sfix)).style.display = "none";
            document.getElementById("ion".concat(sfix)).style.visibility = "hidden";
            document.getElementById("ion".concat(sfix)).style.display = "none";
            document.getElementById("sl3".concat(sfix)).style.visibility = "hidden";
            document.getElementById("sl3".concat(sfix)).style.display = "none";
        }

    }

    function getDist_StatusMsgs(satellite, burstTime, burstStart, burstStop, previousBurst, inc_dir) {
        var currentSpecies = props.getSpecies();
        var h = image_max;
        var l = image_min;
        var finalMatrix = JSON.stringify(matrix);
        axios
            .get(`api/start_dist_workflow?workflow_id=${props.workflowId}&next=${inc_dir}&satellite=${satellite}` +
                `&burstTime=${burstTime}&previousTime=${previousBurst}&species=${currentSpecies}` +
                `&nslices=${which_species.nSlice}&i_high=${h}&i_low=${l}&bulkv=${mytable.bulkv}` +
                `&thickness=${mytable.thickness}&elecEnergyMax=${mytable.elecEnergyMax}&rotation=${mytable.rotation}` +
                `&LMN=${finalMatrix}`
            )
            .then(resp => {
                // Intercept Error

                // Set Loading Status
                const {
                    workflowId,
                    status,
                    progressPercent
                } = resp.data;

                setProgStatus(status);
                setPercent(progressPercent);
                tick_for_dist4(workflowId, 0);
            })
            .catch(error => {
                const message = "An unknown error occurred generating the plots.";
                const redirect = navigate(`/error/${message}`);
            });
    }

    function getDist4Results(workflowId) {
        const progressPercentAtStart = progressPercent;
        const remaining = 100 - progressPercentAtStart;
        const onDownloadProgress = (event) => {
            if (event.lengthComputable) {
                const fraction = event.loaded / event.total;
                const progressPercent = Math.round(
                    progressPercentAtStart + fraction * remaining);
            }
        };
        setProgStatus({ status: "Transferring plot data to your computer" });
        axios
            .get(`api/get_workflow_results_dist4?workflow_id=${workflowId}&nslices=${which_species.nSlice}`,
                { onDownloadProgress })

            .then(resp => {
                const { results } = resp.data;
                const responseDist = resp.data;


                if (!responseDist) {
                    const faux = props.tooMuchData('file transfer'); // file transfer failed (usually Chrome)
                    props.sharedStore.dispatch({
                        type: 'SET_DIST',
                        value: faux
                    });
                } else {
                    props.sharedStore.dispatch({
                        type: 'SET_DIST',
                        value: responseDist
                    });
                    props.getSpecies();
                    resize(responseDist.dist.electron[0].layout, responseDist.dist.electron[0].data[0], 0);
                    resize(responseDist.dist.ion[0].layout, responseDist.dist.ion[0].data[0], 0);
                    resize(responseDist.dist.slice3[0].layout, responseDist.dist.slice3[0].data[0], 0);

                    plotWithSavedRanges('ele-dr0', responseDist.dist.electron[0].data, responseDist.dist.electron[0].layout);
                    plotWithSavedRanges('ion-dr0', responseDist.dist.ion[0].data, responseDist.dist.ion[0].layout);
                    plotWithSavedRanges('sl3-dr0', responseDist.dist.slice3[0].data, responseDist.dist.slice3[0].layout);

                    props.setCurrentStatus("Loading remaining plots...");
                    setTable({
                        ...mytable, rDist: responseDist, rDistCurrent: "electron0"
                    });
                    /* for the initial set, make invisible all but the first,
                                            remove any plots that have already been placed and
                                            make invisible all but the first
                     */
                    for (var i = 1; i < which_species.nSlice; ++i) {
                        resize(responseDist.dist.electron[i].layout, responseDist.dist.electron[i].data[0], 0);
                        resize(responseDist.dist.ion[i].layout, responseDist.dist.ion[i].data[0], 0);
                        resize(responseDist.dist.slice3[i].layout, responseDist.dist.slice3[i].data[0], 0);

                        var thisElem = "ele-dr".concat(i.toString())
                        if (document.getElementById(thisElem).querySelector("svg")) {
                            document.getElementById(thisElem).removeChild(
                                document.getElementById(thisElem).firstElementChild
                            );
                        }
                        thisElem = "ion-dr".concat(i.toString())
                        if (document.getElementById(thisElem).querySelector("svg")) {
                            document.getElementById(thisElem).removeChild(
                                document.getElementById(thisElem).firstElementChild
                            );
                        }
                        thisElem = "sl3-dr".concat(i.toString())
                        if (document.getElementById(thisElem).querySelector("svg")) {
                            document.getElementById(thisElem).removeChild(
                                document.getElementById(thisElem).firstElementChild
                            );
                        }
                    }

                    document.getElementById("ele-dr0").style.visibility = "visible";
                    document.getElementById("ele-dr0").style.display = "inline-block";
                    document.getElementById("ion-dr0").style.visibility = "visible";
                    document.getElementById("ion-dr0").style.display = "inline-block";
                    document.getElementById("sl3-dr0").style.visibility = "visible";
                    document.getElementById("sl3-dr0").style.display = "inline-block";
                    if (document.getElementById("example-dr0") != null) {
                        document.getElementById("example-dr0").style.visibility = "hidden";
                        document.getElementById("example-dr0").style.display = "none";
                    }

                    if (responseDist) {
                        let valid = resp.data.dist.chosen.search("DES");
                        if (valid < 0) {
                            let finddatebegin = resp.data.dist.chosen.search("__");
                            let parse1 = resp.data.dist.chosen.substring(finddatebegin + 2, finddatebegin + 24);
                            setPreviousBurst(parse1.replace("_", "T"));
                            props.sharedStore.dispatch({ type: 'SET_PREVIOUS', value: parse1.replace("_", "T") });
                            props.sharedStore.dispatch({
                                type: 'SET_PREVIOUS',
                                value: parse1.replace("_", "T")
                            });
                        }
                        setTable({
                            ...mytable, rDist: responseDist, rDistCurrent: "electron0"
                        });
                    }

                    document.getElementById("burst-instructions").style.visibility = "visible";
                    document.getElementById("burst-instructions").style.display = "inline";

                    document.getElementById("progress0").style.visibility = "hidden";
                    document.getElementById("progress0").style.display = "none";
                    // next set of dist tools.
                    document.getElementById("burst-instructions").style.visibility = "hidden";
                    document.getElementById("burst-instructions").style.display = "none";
                    document.getElementById("next-set").style.visibility = "visible";
                    document.getElementById("next-set").style.display = "flex";
                    document.getElementById("prev-set").style.visibility = "visible";
                    document.getElementById("prev-set").style.display = "flex";
                    props.sharedStore.dispatch({ type: 'SET_DIST_BUTTON', value: 'next-set' });

                    const dRion0 = document.getElementById('ion-dr0');
                    const dRele0 = document.getElementById('ele-dr0');
                    const dRsl30 = document.getElementById('sl3-dr0');
                    dRion0.on('plotly_relayout', eventData => {
                        if (eventData.hasOwnProperty('xaxis.range[0]')) {
                            onDistZoom('ion-dr0', eventData, dRion0);
                        }
                    });
                    dRele0.on('plotly_relayout', eventData => {
                        if (eventData.hasOwnProperty('xaxis.range[0]')) {
                            onDistZoom('ele-dr0', eventData, dRele0);
                        }
                    });
                    dRsl30.on('plotly_relayout', eventData => {
                        if (eventData.hasOwnProperty('xaxis.range[0]')) {
                            onDistZoom('sl3-dr0', eventData, dRsl30);
                        }
                    });
                    props.sharedStore.dispatch({
                        type: 'SET_DIST_BUTTON',
                        value: "next-set"
                    });

                }
            })
            .catch(error => {
                console.log('error', error);
                const faux = props.tooMuchData('client processing');  // client side processing failed
                props.sharedStore.dispatch({
                    type: 'SET_RESULTS',
                    value: faux
                });
                setProgStatus('Completed');
                setPercent(0);
                props.setCurrentStatus("No burst data error. Move the slider to a position that has burst data");
                setTimeout(() => {
                    const redirect = navigate(`/results/${JSON.stringify(criteria)}`);
                    props.setState({ redirect });
                }, 100);
            });
    }

    /*
    This is called during useEffect so this is why we are settng the ion/electron checkbox here.
     */
    function resize(layout, data, setForExample) {
        var localSpecies = props.getSpecies();
        var local_detail = props.sharedStore.getState().plot_detail;
        if (local_detail != null) {
            setPlotHandler(local_detail);
        }
        // setSpeciesHandler(localSpecies);
        if (localSpecies == "ions") {
            var pzoom = 1500
            var psize = 450
        } else {
            var pzoom = 9000
            var psize = 450
        }
        var user_values_zoom = which_species.currzoom_placeholder;
        var user_values_size = which_species.image_size;
        if (user_values_zoom || user_values_size) { // 100
            // Both ION and ELECTRON image sizes can only be so small...
            if (user_values_size < 230) {
                user_values_size = 450
            }
            // ION can zoom in much closer since it is 10 times slower
            if (localSpecies == "ions") {
                if (user_values_zoom == 0) {
                    user_values_zoom = 1500;
                }
                else if (user_values_zoom < 200) {
                    user_values_zoom = 200
                }
            } else {
                if (user_values_zoom == 0) {
                    user_values_zoom = 12000;
                }
                else if (user_values_zoom < 2000) {
                    user_values_zoom = 2000
                }
            }

            psize = parseInt(user_values_size);
            pzoom = parseInt(user_values_zoom);
        }
        if (which_species.user_values_size !== user_values_size || which_species.currzoom_placeholder !== user_values_zoom) {
            setSpecies({ ...which_species, image_size: user_values_size, currzoom_placeholder: user_values_zoom });
        }
        layout.height = psize;
        layout.width = psize;
        layout.xaxis.range = [-pzoom, pzoom];
        layout.yaxis.range = [-pzoom, pzoom];
        var adjust = Math.floor(psize) / 50
        adjust = adjust + 1
        if (pzoom >= 450) {
            adjust = Math.floor(psize / 35)
        }

        if (setForExample == 1) {
            layout.title.text = "Example Burst Distribution";
        }
        layout.title.font.size = adjust;
        layout.xaxis.tickfont.size = adjust;
        layout.yaxis.tickfont.size = adjust;
        layout.xaxis.title.font.size = adjust;
        layout.yaxis.title.font.size = adjust;
        data.colorbar.tickfont.size = adjust;

    }

    function tick_for_dist4(workflowId, tickCount) {
        tickCount = tickCount + 1;
        axios
            .get(`api/poll_workflow?workflow_id=${workflowId}&tick=${tickCount}`)
            .then(resp => {
                const {
                    status,
                    progressPercent,
                    done
                } = resp.data;

                if (done) {
                    /* in case we are reloading files and don't hit intermediate progress values */
                    setPercent(100);
                    props.setCurrentStatus("Loading first 3 of " + (which_species.nSlice * 3).toString() + " distribution plots..." + " " + tickCount);
                    getDist4Results(workflowId); // I'll need to write this guy
                    return;
                }
                if (progressPercent > 0) {
                    props.setCurrentStatus(status + " " + tickCount);
                    document.getElementById("progress0").style.visibility = "visible";
                    document.getElementById("progress0").style.display = "inline";
                }
                setProgStatus(status)
                if (progressPercent + tickCount <= 100) {
                    var currentPercent = progressPercent + tickCount
                    setPercent(currentPercent);
                }
                timerRef.current = setTimeout(() =>
                    tick_for_dist4(workflowId, tickCount), Constants.PROGRESS_POLL_INTERVAL);
            })
            .catch(error => {
                const message = "An unknown error occurred when checking on the workflow.";
                const redirect = navigate(`/error/${message}`);
            });
    }


    function do_we_have_burst_tracker() {
        if (document.getElementById('plotly-results')) {
            var gd = document.getElementById('plotly-results');
            if (gd.data != null) {
                if (gd.data[1].hovertemplate === '%{customdata}') { // if burst tracker is here it will be in data[1]
                    return true
                }
            }
        }
        return false
    }

    function update_main_slider_pos(new_pos) {
        var gd = document.getElementById('plotly-results');
        if (new_pos != null) {
            var update = {
                'shapes[0].visible': true,
                'shapes[0].x0': new_pos,
                'shapes[0].x1': new_pos,
            }
            props.sharedStore.dispatch({
                type: 'SET_SLIDER_COND', value: "auto"
            });

            Plotly.relayout(gd, update);
        }

    }
    function showMainSlider(truefalse) {
        props.setShowLine(truefalse);
        props.sharedStore.dispatch({
            type: 'SET_SLIDER_COND', value: "user"
        });

        var gd = document.getElementById('plotly-results');
        if (props.mid_time != null) {
            var update = {
                'shapes[0].visible': truefalse,
                'shapes[0].x0': props.mid_time,
                'shapes[0].x1': props.mid_time
            }
            // this is in ResultsScreen setLinePos(props.mid_time);
        }
        else {
            var update = {
                'shapes[0].visible': truefalse,
            }
        }
        Plotly.relayout(gd, update);
        if (document.getElementById("electron-distributions-results")) {
            document.getElementById("electron-distributions-results").style.visibility = "visible";
            document.getElementById("electron-distributions-results").style.display = "block";
        }

        document.getElementById("burst-instructions").style.visibility = "visible";
        document.getElementById("burst-instructions").style.display = "block";
        if (!startDist) {
            setStartDist(true);
        }
        props.sharedStore.dispatch({
            type: 'SET_DIST_BUTTON', value: "slider-button"
        });
    }

    const onDistZoom = (thisDistDiv, eventData, thisPlotlyDiv) => {

        for (let prefix of ["ion", "ele", "sl3"]) {

            for (let suffix of ["-dr0", "-dr1", "-dr2", "-dr3", "-dr4"]) {
                var gd = document.getElementById(prefix.concat(suffix));
                if (gd.className.includes('plotly')) {
                    Plotly.relayout(gd, {
                        'xaxis.range': [eventData['xaxis.range[0]'],
                        eventData['xaxis.range[1]']],
                        'yaxis.range': [eventData['yaxis.range[0]'],
                        eventData['yaxis.range[1]']]
                    })
                }
            }
        }

    }

    function custom_reset_axis() {
        for (let prefix of ["ion", "ele", "sl3"]) {
            for (let suffix of ["-dr0", "-dr1", "-dr2", "-dr3", "-dr4"]) {
                var gd = document.getElementById(prefix.concat(suffix));
                if (gd.className.includes('plotly')) { // this means it has plotly object in it
                    let pzoom = which_species.currzoom_placeholder;
                    Plotly.relayout(gd, {
                        //'xaxis.autorange': true,
                        //'yaxis.autorange': true
                        'xaxis.range': [-pzoom, pzoom],
                        'yaxis.range': [-pzoom, pzoom]
                    })
                }
            }
        }
        setTimeout(() => {
            setCurrentRanges({ x: [-which_species.currzoom_placeholder, which_species.currzoom_placeholder], y: [-which_species.currzoom_placeholder, which_species.currzoom_placeholder] });
        }, 100);
    }

    function enablePanZoom(mode) {
        const prefixes = ["ion", "ele", "sl3"];
        const suffixes = ["-dr0", "-dr1", "-dr2", "-dr3", "-dr4"];
        if (mode) {
            prefixes.forEach(prefix => {
                suffixes.forEach(suffix => {
                    const id = prefix + suffix;
                    const gd = document.getElementById(id);
                    if (gd && gd.className.includes("plotly")) {
                        Plotly.relayout(gd, {
                            dragmode: 'pan',
                            scrollZoom: true
                        });
                    }
                });
            });
        } else {
            prefixes.forEach(prefix => {
                suffixes.forEach(suffix => {
                    const id = prefix + suffix;
                    const gd = document.getElementById(id);
                    if (gd && gd.className.includes("plotly")) {
                        Plotly.relayout(gd, {
                            dragmode: 'zoom',
                            scrollZoom: true
                        });
                    }
                });
            });
        }
    }

    function downloadPlot(form) {
        const prefixes = ["ion", "ele", "sl3"];
        const suffixes = ["-dr0", "-dr1", "-dr2", "-dr3", "-dr4"];

        prefixes.forEach(prefix => {
            suffixes.forEach(suffix => {
                const id = prefix + suffix;
                const gd = document.getElementById(id);
                if (gd && gd.className.includes("plotly") && gd.getAttribute("style").indexOf("visible") != -1) {
                    Plotly.downloadImage(gd, {
                        format: form,
                        filename: id,
                    });
                }
            });
        });
    }

    function adjust_colorbar(thisPlotlyDiv, currentMax, currentMin, relayout_signal) {
        var n = thisPlotlyDiv.data[0].colorscale.length;

        if (relayout_signal == 1) {
            var cscale = [
                [0, 'rgb(0,0,131)'],
                [.2, 'rgb(0,60,170)'],
                [.4, 'rgb(5,255,255)'],
                [.6, 'rgb(255,255,0)'],
                [.8, 'rgb(250,0,0)'],
                [1, 'rgb(128,0,0)']
            ];
            thisPlotlyDiv.data[0].colorscale = cscale;
            return thisPlotlyDiv;
        }

        var cscale = [ // 27
            [0, 'rgb(0,0,131)'],
            [0, 'rgb(0,12,139)'],
            [0, 'rgb(0,24,147)'],
            [0, 'rgb(0,36,155)'],
            [0, 'rgb(0,48,162)'],

            [.2, 'rgb(0,60,170)'],
            [.2, 'rgb(1,100,187)'],
            [.2, 'rgb(2,140,201)'],
            [.2, 'rgb(3,180,221)'],
            [.2, 'rgb(4,220,238)'],

            [.4, 'rgb(5,255,255)'],
            [.4, 'rgb(45,255,205)'],
            [.4, 'rgb(95,255,155)'],
            [.4, 'rgb(135,255,105)'],
            [.4, 'rgb(180,255,55)'],
            [.4, 'rgb(220,255,5)'],

            [.6, 'rgb(255,255,0)'],
            [.6, 'rgb(254,205,0)'],
            [.6, 'rgb(253,155,0)'],
            [.6, 'rgb(252,105,0)'],
            [.6, 'rgb(251,55,0)'],

            [.8, 'rgb(250,0,0)'],
            [.8, 'rgb(225,0,0)'],
            [.8, 'rgb(200,0,0)'],
            [.8, 'rgb(175,0,0)'],
            [.8, 'rgb(150,0,0)'],
            [1, 'rgb(128,0,0)'],
        ];

        let start = Math.floor((currentMin / 255) * cscale.length) - 2;
        let end = Math.floor((currentMax / 255) * cscale.length) + 2;
        let delta = Math.floor((end - start) / n)
        for (let i = 0; i < n; ++i) {
            let jump = start + i * delta
            thisPlotlyDiv.data[0].colorscale[i][1] = cscale[jump][1];
        }

        return thisPlotlyDiv;
    }

    function drawDivs() {
        var ion_divs = [];
        var ele_divs = [];
        var sl3_divs = [];



        for (let i = 1; i < which_species.nSlice; ++i) {
            let suffix = i.toString();
            let thisDiv = "ion-dr".concat(suffix);
            ion_divs.push(<div id={thisDiv} key={thisDiv} style={{ visibility: "hidden", display: "none" }}></div>);
            thisDiv = "ele-dr".concat(suffix);
            ele_divs.push(<div id={thisDiv} key={thisDiv} style={{ visibility: "hidden", display: "none" }}></div>);
            thisDiv = "sl3-dr".concat(suffix);
            sl3_divs.push(<div id={thisDiv} key={thisDiv} style={{ visibility: "hidden", display: "none" }}></div>);
        }

        var e = document.getElementById('ion-dr0');
        if (e !== null) {
            if (e.classList.contains('js-plotly-plot')) {
                props.setfirstDistLoad(false);
            }
        }


        return (
            <React.Fragment>

                <div id="ion-dr0"></div>
                {ion_divs}
                <div id="ele-dr0"></div>
                {ele_divs}
                <div id="sl3-dr0"></div>
                {sl3_divs}
            </React.Fragment>
        )
    }

    function displayTime() {
        if (editTime) {
            return (
                <div><p className={'slider-timer-disp edit-input'}>Slider Position: <span className='time-display'>{lineTime.date}</span>
                    <input type="text" id="burst-start-time-hour" name='burst-time-hour' className='time-input' onChange={e => setLineTime({
                        ...lineTime,
                        hour: e.target.value,
                    })} value={lineTime.hour} />:
                    <input type="text" id="burst-start-time-min" name='burst-time-min' className='time-input' onChange={e => setLineTime({
                        ...lineTime,
                        min: e.target.value,
                    })} value={lineTime.min} />:
                    <input type="text" id="burst-start-time-sec" name='burst-time-sec' className='time-input' onChange={e => setLineTime({
                        ...lineTime,
                        sec: e.target.value,
                    })} value={lineTime.sec} />.
                    <input type="text" id="burst-start-time-mil" name='burst-time-mil' className='time-input mil' onChange={e => setLineTime({
                        ...lineTime,
                        mil: e.target.value,
                    })
                    } value={lineTime.mil} />
                </p>
                    <div className='time-edit-btns-div'>
                        <button type="reset" className='time-edit-btns buttonHouse' onClick={() => { setTimeObj(false); setEditTime(!editTime); }}>Cancel</button>
                        <button type="submit" className='time-edit-btns buttonHouse' onClick={() => setNewTime()} >Submit</button></div></div>
            );
        } else if (linePos === props.line_pos) {
            return (<p className={'slider-timer-disp'}><span className='slider'>Slider Position: </span><span className='time-display'>{props.line_pos} <button onClick={() => { setTimeObj(false); setEditTime(!editTime); }} className='edit-button'><img
                src={edit} className="edit-svg" alt="edit time" /></button></span></p>);
        } else {
            return (<p className={'slider-timer-disp new'}><span className='slider'>New Slider Position: </span><span className='time-display'>{props.line_pos} <button onClick={() => { setTimeObj(false); setEditTime(!editTime); }} className='edit-button'><img
                src={edit} className="edit-svg" alt="edit time" /></button></span></p>);
        }
    };

    // needed for smooth transition and to fully remove page from elements for accessibility
    function bustVarAccordion() {
        if (!disableAccordion) {
            if (hideBurstVar) {
                setDisableAccordion(true);
                setDelayHideVar(false);
                setTimeout(() => {
                    setHideBurstVar(false);
                }, 50);
                setTimeout(() => {
                    setDisableAccordion(false);
                }, 400);
            } else {
                setDisableAccordion(true);
                setHideBurstVar(true);
                setTimeout(() => {
                    setDelayHideVar(true);
                    setDisableAccordion(false);
                }, 400);
            }

        }
    }

    function setTimeObj(setNewPos) {
        if (setNewPos) {
            setLinePos(props.line_pos);
        }
        let spliceArray = props.line_pos.split(/[\s.:T]+/);
        console.log(spliceArray);
        setLineTime({
            date: spliceArray[0],
            hour: spliceArray[1],
            min: spliceArray[2],
            sec: spliceArray[3],
            mil: spliceArray[4].slice(-3),
        })
    }
    return (
        <div className={"dist-container " + (hideBurstVar ? '' : 'openVar')}>

            <div className="left-arrow-container">
                <div id="prev-set" className="left-arrow-inner-container" style={{ visibility: "hidden", display: "none" }}>
                    <button className="next-dist-left" onClick={() => DisplayNext(-1)}>
                        <div className="leftarrow-dist" />
                        <label id="time_label" className="left-time-label arrowtext"
                            htmlFor="ion_sel">Previous {deltaTime}</label>
                    </button>
                    {/* <Tooltip title="Show the previous set of 3, already loaded distribution plots" placement="top">
                    </Tooltip> */}

                    <button className="arrow-housing-dist-left" href={"#"} onClick={() => prev_file()}>
                        <div className="leftarrow-dist-double" />
                        <label className="next-set-label-left arrowtext">Previous Set {skipTime}</label>
                    </button>
                    {/* <Tooltip title="Build and Display the next set of Distribution plots" placement="top">
                    </Tooltip> */}
                </div>
            </div>
            <Grid item xs={12} style={{ overflow: "hidden" }}> {/* Distributions grid  this is the third vertical grid for the whole page*/}
                <Grid container direction="column" justifyContent="center" alignItems="center">

                    <Grid item xs={12}>
                        <h2 className='plot-subheaders burst'>Burst Distributions </h2>
                    </Grid>
                    <div className='time-display-set'>
                        {(props.line_pos !== '' && props.showLine) ? displayTime() : <p className={'slider-timer-disp'}>Slider Position: <span className='time-display'>None</span></p>}

                    </div>
                    <Grid item xs={12} className={!startDist ? 'show' : 'hide'}>
                        <div class="top-dist-container">
                            <div id="start_with_distributions">
                                <button className="tour_click_here buttonHouse" href={"#"}
                                    onClick={(event) => showMainSlider(true)} disabled={props.disableButton}>
                                    <span className='dist-generate'>Generate Distributions</span>
                                </button>
                                <div className={'start-text'}>
                                    <p>To view distributions, click the Generate Distributions button above</p>
                                    <p>Then, using the dashed gray burst-tracker line as a guide (at the top of the plots to the ledt), move the vertical blue time slider left or right to select a Burst Distribution time period.</p>
                                    <p>The blue slider must be over a selction of the dashed gray burst-tracker line to generate data.</p>
                                </div>

                            </div>
                        </div>
                    </Grid>


                    <Grid item xs={12} style={{ width: "100%" }}>
                        <div id="middle-dist-id" className={'middle-dist-container ' + (startDist ? 'show' : 'hide')}>


                            <i className='burst-instructions' id="burst-instructions" style={{ visibility: "hidden", display: "none" }}>
                                Next, move the slider to desired time position</i>

                            {/* GRID */}
                            <div id="progress0" style={{ visibility: "hidden", display: "none" }}>
                                <h7>Distributions: {props.cs}</h7>
                                <center className='progress-bar'>
                                    <LinearProgress
                                        variant="determinate"
                                        value={progressPercent} />
                                </center>
                            </div>
                            {/* settings button */}
                            <button class="dist-button-container" onClick={() => bustVarAccordion()}><svg className={`arrow-direction-${hideBurstVar} settings-arrows`} viewBox="0 0 24 24">
                                <path d="M7 10l5 5 5-5z"></path></svg>
                                <span>Settings</span>
                            </button>
                            <Grid container columnSpacing={2} direction="column" className={'dist-button-container-gird'}>
                                {delayHideVar ? '' :
                                    <div id="dist-button" className={`burst-var ${hideBurstVar ? "hide-burst-var" : ""}`} >
                                        <Grid container direction="column" style={{ flexWrap: "nowrap" }}>
                                            <h3 className='radioHeader'>Partials Measured</h3>
                                            <FormControl>
                                                <RadioGroup
                                                    column
                                                    aria-labelledby="Set species handler"
                                                    className="Ion-select-radio"
                                                    value={which_species.species}
                                                    onChange={(event) => {
                                                        setSpeciesHandler(event.target.value);
                                                    }}
                                                >
                                                    <FormControlLabel className='ion-elec burst-radio' value={"ions"} control={<Radio color="default" size="small" />} label="Ion" id="ion-sel" />
                                                    <FormControlLabel className='ion-elec burst-radio' value={"electron"} control={<Radio color="default" size="small" />} label="Electron" id="electron-sel" />
                                                </RadioGroup>
                                            </FormControl>
                                            <h3 className='radioHeader'>Distribution Type</h3>
                                            <FormControl>
                                                <RadioGroup
                                                    column
                                                    aria-labelledby="rotation handler"
                                                    className="Ion-select-radio"
                                                    value={mytable.rotation}
                                                    onChange={(event) => {
                                                        handleRotationChange(event.target.value);
                                                    }}
                                                >
                                                    <FormControlLabel className='burst-radio' value={"GSE"} control={<Radio color="default" size="small" />} label="GSE" id="gse-sel" />
                                                    <FormControlLabel className='burst-radio' value={"B"} control={<Radio color="default" size="small" />} label="B" id="b-sel" />
                                                    <FormControlLabel className='burst-radio' value={"LMN"} control={<Radio color="default" size="small" />} label="LMN" id="lmn-sel" />
                                                </RadioGroup>
                                            </FormControl>
                                            <h3 className='radioHeader'>Subtract Vbulk</h3>
                                            <FormControl>
                                                <RadioGroup
                                                    column
                                                    aria-labelledby="Subtract Vbulk select"
                                                    className="brow-publish-radio"
                                                    value={mytable.bulkv}
                                                    onChange={(event) => {
                                                        handleBulkVChange(event.target.value);
                                                    }}
                                                >
                                                    <FormControlLabel className='brow-pub burst-radio' value={true} control={<Radio color="default" size="small" />} label="Yes" id="yes-sel" />
                                                    <FormControlLabel className='brow-pub burst-radio' value={false} control={<Radio color="default" size="small" />} label="No" id="no-sel"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                            <h3 className='radioHeader'>Layout</h3>
                                            <FormControl>
                                                <RadioGroup
                                                    column
                                                    aria-labelledby="plot handler select"
                                                    className="brow-publish-radio"
                                                    value={which_species.plot_detail}
                                                    onChange={(event) => {
                                                        setPlotHandler(event.target.value);
                                                    }}
                                                >
                                                    <FormControlLabel className='brow-pub burst-radio' value={"browse"} control={<Radio color="default" size="small" />} label="Browse" id="browse-sel" />
                                                    <FormControlLabel className='brow-pub burst-radio' value={"publish"} control={<Radio color="default" size="small" />} label="Publish" id="publish-sel"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                        <Grid container direction="column" style={{ flexWrap: "nowrap" }}>
                                            <div className="image-size">
                                                <label for="size" class='label'>Image Size (px):</label>
                                                <div className='burst-nubmer-input'>
                                                    <RemoveIcon onClick={() => { decrementSizeValue() }} variant="contained" style={{ color: '#999999', margin: '3px', width: '1rem' }} ></RemoveIcon>
                                                    <input type="text" id="resize-value-size" value={which_species.image_size} name="size" onChange={(event) => { setSpecies({ ...which_species, image_size: event.target.value }); }} />
                                                    <AddIcon onClick={() => { incrementSizeValue() }} variant="contained" style={{ color: '#999999', margin: '3px', width: '1rem' }}></AddIcon>
                                                </div>
                                            </div>
                                            <div className="zoom-level">
                                                <label for="zoom" className='zoomText label'>Zoom (km/s):</label>
                                                <div className='burst-nubmer-input'>
                                                    <RemoveIcon onClick={() => { decrementZoomValue() }} variant="contained" style={{ color: '#999999', margin: '3px', width: '1rem' }} ></RemoveIcon>
                                                    <input type="text" id="resize-value-zoom" name='zoom'
                                                        value={which_species.currzoom_placeholder} onChange={(event) => { setSpecies({ ...which_species, currzoom_placeholder: event.target.value }); }} />
                                                    <AddIcon onClick={() => { incrementZoomValue() }} variant="contained" style={{ color: '#999999', margin: '3px', width: '1rem' }}></AddIcon>
                                                </div>
                                            </div>
                                            <div className="slice-thickness">
                                                <label htmlFor="size" className='slice-thickness-label'>Slice Thickness:</label>
                                                <div className='burst-nubmer-input'>
                                                    <RemoveIcon onClick={() => { decrementhandleThickness() }} variant="contained" style={{ color: '#999999', margin: '3px', width: '1rem' }} ></RemoveIcon>
                                                    <input type="text" id="slice-thickness" value={mytable.thickness} name="size"
                                                        onChange={(event) => {
                                                            handleThickness(event.target.value)
                                                        }} />
                                                    <AddIcon onClick={() => { incrementhandleThickness() }} variant="contained" style={{ color: '#999999', margin: '3px', width: '1rem' }}></AddIcon>
                                                </div>
                                            </div>
                                            <div className="electron-energy-max">
                                                <label htmlFor="size" className='electron-energy-max-label'>Max Energy:</label>
                                                <div className='burst-nubmer-input'>
                                                    <RemoveIcon onClick={() => { decrementElecEnergyMax() }} variant="contained" style={{ color: '#999999', margin: '3px', width: '1rem' }} ></RemoveIcon>
                                                    <input type="text" id="electron-max" value={mytable.elecEnergyMax} name="size"
                                                        onChange={(event) => {
                                                            handleElecEnergyMax(event.target.value)
                                                        }} />
                                                    <AddIcon onClick={() => { incrementElecEnergyMax() }} variant="contained" style={{ color: '#999999', margin: '3px', width: '1rem' }}></AddIcon>
                                                </div>
                                            </div>

                                            <label for='color' class='label color-range'>
                                                Color Range:
                                            </label>
                                            <div>
                                                <div className="squeezebar color-slider">
                                                    <Tooltip
                                                        title="To show more detail in a particular range, adjust the slider to apply the entire palette of colors to that smaller span of values"
                                                        placement="top">
                                                        <div>
                                                            <MultiRangeSlider min={0}
                                                                name="color"
                                                                max={255}
                                                                minValue={image_min}
                                                                maxValue={image_max}
                                                                onChange={({ minValue, maxValue }) => {
                                                                    get_slider(minValue, maxValue);
                                                                }}
                                                            />
                                                        </div>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div className={mytable.rotation === "LMN" ? '' : 'disabled'}>
                                                <label className='label lmn'>LMN Rotation Matrix (GSE)</label>
                                                <div className='matrix'>
                                                    {matrix.map((innerArray, outerIndex) => {
                                                        let labelArray = ['L', 'M', 'N']
                                                            ; return (
                                                                <div className='matrix-row'>
                                                                    <label>{labelArray[outerIndex]}</label>{
                                                                        innerArray.map((num, index) => {
                                                                            return (
                                                                                <input className={'matrix-input ' + (mytable.rotation === "LMN" && ((isNaN(matrix[outerIndex][index]) || matrix[outerIndex][index] < -1 || matrix[outerIndex][index] > 1) ? 'invalid' : ''))} value={matrix[outerIndex][index]} onChange={e => {
                                                                                    let newMatix = [...matrix];
                                                                                    newMatix[outerIndex][index] = e.target.value;
                                                                                    setMatrix(newMatix);
                                                                                }} />
                                                                            )
                                                                        })}</div>)
                                                    })}
                                                </div>
                                            </div>
                                            <div id="next-set-server-tools-div" className='apply-div'>
                                                <Tooltip title="Reload" placement="top">
                                                    <button disabled={!reload} className={"tour_apply buttonHouse "} onClick={() => same_time_file()} style={{ marginRight: '4px', marginTop: "2rem" }}>
                                                        <label className='apply'
                                                            style={{ padding: "0px", fontweight: '400' }}>Apply</label>
                                                    </button>
                                                </Tooltip>
                                            </div>
                                        </Grid>
                                    </div>
                                }
                            </Grid>
                            <hr class="divider burst"></hr>
                            <div className='dist-plot-container'>
                                {// Toggle: Only show when data is loadded
                                    false ? '' :
                                        <button className="dist-options-icon" id="open-options-button-dist" onClick={() => {
                                            setShowOptions(!showOptions);
                                        }}></button>
                                }
                                {showOptions ?
                                    <dialog className="dist-options-modal" id="options-dialog-dist">
                                        <ul className="dist-options-ul">
                                            <li>
                                                <button className={"dist-options-button"} onClick={() => custom_reset_axis()}>Reset Axis</button>
                                            </li>
                                            {/* <li>
                                                <button className={"dist-options-button"} onClick={() => enablePanZoom()}>Enable Pan</button>
                                            </li> */}
                                            <li>
                                                <button className={"dist-options-button"} onClick={() => downloadPlot('png')}>Download Plots as PNG</button>
                                            </li>
                                            <li>
                                                <button className={"dist-options-button"} onClick={() => downloadPlot('svg')}>Download Plots as SVG</button>
                                            </li>
                                            <li className="options-checkbox first">
                                                <Checkbox className=''
                                                    size="small"
                                                    checked={enablePan}
                                                    onChange={() => {
                                                        setEnablePan(!enablePan);
                                                        enablePanZoom(!enablePan);
                                                    }}
                                                    color="default"
                                                />
                                                <span
                                                    className='options-checkbox-text'
                                                    onClick={() => {
                                                        setEnablePan(!enablePan);
                                                        enablePanZoom(!enablePan);
                                                    }}
                                                >
                                                    Enable Pan
                                                </span>
                                            </li>
                                        </ul>
                                    </dialog>
                                    : ''}
                                {/* <button disabled={!reload} className={"tour_apply buttonHouse "} onClick={() => custom_reset_axis()} style={{ marginRight: '4px', marginTop: "2rem" }}>
                                    <label className='apply'
                                        style={{ padding: "0px", fontweight: '400' }}>House Icon</label>
                                </button> */}
                                {drawDivs()}
                            </div >
                        </div>
                    </Grid>
                </Grid>
            </Grid >


            <div class="right-arrow-container">
                <div id="next-set" class="right-arrow-inner-container" style={{ visibility: "hidden", display: "none" }}>
                    <button className="next-dist-right" onClick={() => DisplayNext(1)}>
                        <label id="time_label" class="right-time-label arrowtext" htmlFor="ion_sel"
                        >Next {deltaTime}</label>
                        <div className="rightarrow-dist" />
                    </button>
                    {/* <Tooltip title="Show the next set of 3, already loaded, distribution plots" placement="top">
                    </Tooltip> */}


                    <button className="arrow-housing-dist-right" href={"#"} onClick={() => next_file()}>
                        <label class="next-set-label-right arrowtext" htmlFor="ion_sel"
                        >Next set {skipTime}</label>
                        <div className="rightarrow-dist-double" />
                    </button>
                    {/* <Tooltip title="Build and Display the next set of Distribution plots" placement="top">
                    </Tooltip> */}
                </div>
            </div>
        </div >
    );
}
export default Distributions;